import BccRwdLinkHOC from 'components/Bcc/BccRwdLinkHOC/BccRwdLinkHOC';

export default BccRwdLinkHOC;
